import { handleAction, handleActions } from 'redux-actions';
import { CLEAR_PROMO_CODE, clearPromoCode, PromoCodeActions, SET_PROMO_CODE, setPromoCode } from './actions';

export type PromoCodeState = string;

export const defaultState: PromoCodeState = '';

export const setPromoCodeHandler = handleAction<PromoCodeState, string>(
	setPromoCode,
	(state, action) => action.payload,
	defaultState
);

export const clearPromoCodeHandler = handleAction<PromoCodeState, unknown>(
	clearPromoCode,
	(state, action) => '',
	defaultState
);

export default handleActions<PromoCodeState, PromoCodeActions>(
	{
		[SET_PROMO_CODE]: setPromoCodeHandler,
		[CLEAR_PROMO_CODE]: clearPromoCodeHandler
	},
	defaultState
);
